import type { ReactNode } from 'react';

export function JourneyHelp({ title, children }: { title: string; children: ReactNode }) {
  return (
    <details className="journey-help">
      <summary>{title}</summary>
      <div>{children}</div>
    </details>
  );
}
